<template>
	<v-layout row wrap mb-3>
		<v-flex xs10>
			<v-subheader>{{title}}</v-subheader>
		</v-flex>
		<div class="d-flex align-center">
			<v-switch
				class="mt-0 pt-0"
				:disabled="disabled"
				v-model="current"
				color="primary"
				hide-details
				@change="$emit('input', current)"
				aria-label="label"
			></v-switch>
				<v-tooltip class="ml-2" bottom max-width="480px">
							<template v-slot:activator="{ on }">
								<v-icon color="primary" dark v-on="on">info</v-icon>
							</template>
							<span>
								{{ information }}
							</span>
						</v-tooltip>
                    </div>
	</v-layout>
</template>

<script>
	export default {
		name: "egrantySwitchInfo",

		data() {
			return {
				current: false,
			};
		},

		watch: {

			value: {
				immediate: true,
				handler(newVal) {
					this.current = newVal;
				},
			},
		},


		props: {
			title: {type: String, default: "Nazwa"},

			value: Boolean,
			disabled: {default: false},
            information: {type: String, default: ""}
		},

	};
</script>

<style scoped>

</style>
